import React from 'react'
import Button from '../../atoms/Button'
import Link from '../../atoms/Link'
import { useMenuHandles } from '../../contextModels/MenuContext'
import * as style from './style.module.scss'

const MainMenu = ({ menu }) => {
    const { isMenuActive } = useMenuHandles()

    const menuClass = [style.menu]
    if (isMenuActive) {
        menuClass.push(style.menu_active)
    }

    return (
        <nav className={menuClass.join(' ')}>
            <div className={style.menuBar}>
                <ul className={style.menuList}>
                    {menu.map((item) => (
                        <PrimaryLevel
                            key={item.label}
                            item={item}
                            slug={item.label}
                        />
                    ))}
                </ul>
            </div>
        </nav>
    )
}

const PrimaryLevel = React.memo(({ item }) => {
    const { cssClasses, label, slug, target, url } = item

    const liClasses = [style.menuItem]

    if (cssClasses.includes('primary')) {
        liClasses.push('style.menuItem_cta')
    }

    return (
        <li className={liClasses.join(' ')}>
            {cssClasses.includes('primary') ? (
                <Button
                    color="lightblue"
                    fluid
                    to={slug === 'home' ? '/' : url}
                    type="link"
                >
                    {label}
                </Button>
            ) : (
                <Link
                    activeClassName={style.menuLink_active}
                    className={style.menuLink}
                    partiallyActive
                    target={target || '_self'}
                    to={slug === 'home' ? '/' : url}
                >
                    {label}
                </Link>
            )}
        </li>
    )
})

export default MainMenu
